<template lang="pug">
  v-navigation-drawer(  
    v-model='visible'
    app 
    id="sidebarV2Id"
    :mini-variant='expandStatus && !isMobile'
    :expand-on-hover='!isMobile'
    :permanent='!isMobile'
  ).drawerCustom
    v-row(
      align="center" 
      justify="center" 
    ).my-3
      h5.white--text {{ $t('menu') }} 
    div(
      id="listDrawerV2"
      style="height:90%;"
      class="overflow-y-auto"
      @scroll="handleScroll"
    )
      v-list-item(
        v-for='(link,i) in items',  
        :key='i'       
        v-show='checkNavItemCond(link)'
        @click='goTo(link)'
        @scroll="handleScroll"
      )
        //- :to='i === 0 ? { path:link.to }  : { name:link.pathName }'
        v-list-item-icon
          v-img(:src='link.imgWhite', width='20')
        v-list-item-content
          v-list-item-title.white--text
            b {{ link.name }}
      v-list-item(@click='$refs.rule.open()')
        v-list-item-icon
          v-img(src='@/assets/nav/submenu/icon_submenu13.svg', width='20')
        v-list-item-content
          v-list-item-title.white--text
            b {{ $t('rules-regulation') }}
      v-list-item(@click='logout()')
        v-list-item-icon
          v-img(src='@/assets/nav/submenu/icon_submenu14.svg', width='20')
        v-list-item-content
          v-list-item-title.white--text
            b {{ $t('logout') }}  
      v-list-item
      v-list-item
      v-list-item 
      dialog-rule-main(ref='rule')   
    v-list-item( 
      @click="isBottomPosition ? scrollUpList() : scrollEndList()"
    )
      v-row( 
        justify="center" 
        no-gutters
      ).mb-5
        v-icon(dark v-if='!isBottomPosition') mdi-chevron-down 
        v-icon(dark v-else) mdi-chevron-up
    <dialog-contact-agent ref="dialogContactAgent" />

</template>
<script> 
import { 
  auth as apiAuth,
} from '@/apis' 
import DialogRuleMain from '@/components/Dialog/DialogRuleMain'   
import { ROUTE_CONTACT } from '@/const/route' 
import { SPECIAL_ROLE_GROUP } from '@/const/roleId'
import dialogContactAgent from '@/components/Dialog/DialogContactAgent'
import { ROUTE_LOGIN } from '@/const/route' 

export default {
  components : {
    DialogRuleMain,
    dialogContactAgent
  },
  props: { 
    expandStatus: {
      type: Boolean,
      default: true
    },
    marqueeStatus : {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    visible: false,
    isBottomPosition: false
  }),
  computed : {
    items () { 
      return this.$store.getters['sidebarItems/GETTERS_ITEMS'] 
    },
    isMobile () {
      return !this.$vuetify.breakpoint.mdAndUp
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    userRoleId () {
      return ((this.userProfile || {}).role || {}).id
    }, 
  },
  methods: {
    checkNavItemCond (item) {
      const isNotRoleUser = SPECIAL_ROLE_GROUP.includes(this.userRoleId)
      const isUserRoleDis = !item.onlyUser || !isNotRoleUser
      return item.imgWhite && !item.Isclosed && isUserRoleDis 
    },
    goTo (item) { 
      if(item.newtab) { 
        window.open(item.to, '_blank');
      } else if (item.pathName == ROUTE_CONTACT) {
        this.$refs.dialogContactAgent.open()
      } else {
        this.$router.push({ name:item.pathName }).catch(()=>{}); 
      }
      this.GAsidebar(item.name)
    },
    scrollUpList () {
      const objDiv = document.getElementById('listDrawerV2')
      objDiv.scrollTop = 0
    },
    scrollEndList () {
      const objDiv = document.getElementById('listDrawerV2')
      objDiv.scrollTop = objDiv.scrollHeight
    },
    handleScroll (el) { 
      // Edit Preload here !!
      const preLoadHeight = 200
      if (
        el.target.offsetHeight + el.target.scrollTop >=
        el.target.scrollHeight - preLoadHeight
      ) {
        this.isBottomPosition = true
      }else { 
        this.isBottomPosition = false
      }
    },
    openSideBar () {
      this.$ga.event('Button', 'OpenSideBarMobile', 'SideBar-V2','' ) 
      this.visible=!this.visible
    },
    GAsidebar (name){
      this.$ga.event('Button', 'SelectPage', 'SideBar-V2',name )
    },

    async logout () {
      this.$confirm('',this.$t('confirm.logout'),'warning').then(async ()=>{ 
        // window.removeEventListener('focus', this.checkCurrentGame);
        await apiAuth.logout() 
        this.$store.dispatch('auth/ACTION_LOGOUT') 
        this.$ga.event('Button', 'Logout', 'SideBar-V2','' )
    
        this.$router.push({ name: ROUTE_LOGIN }).then(() => {
          location.reload(); // Forces a full page reload
        }).catch(() => {});
      }) 
    },
  }
}
</script>
<style scoped>
.drawerCustom {
  margin-top:70px; 
  padding-top:10px; 
  padding-bottom:10px; 
  height: 90vh !important;
  /* background-color: var(--bg-secondary-color-v2) !important; */
  background-image: linear-gradient(var(--bg-secondary-color-v2), var(--bg-secondary-color-v2-end)) !important;
  border-top-right-radius:20px; 
  border-bottom-right-radius:20px;
  -ms-overflow-style: none !important; 
  scrollbar-width: none !important; 
} 
.drawerCustom >>> .v-navigation-drawer__content {
  overflow-y:hidden !important;
} 
.drawerCustom ::-moz-scrollbars {
  display:none !important;
} 

.drawerCustom ::-webkit-scrollbar {
  width: 0 !important; 
  display: none !important;
}
</style>